import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import {getTreeNode} from "@/api/system/role";
import { mapGetters, mapActions } from "vuex";
import { tabsList } from "@/api/portrayal/policy";
export default {
  props: {
    initId: {
      type: String,
      required: false,
      default: 0
    },
    showShadow: {
      type: Boolean,
      required: false,
      default: true
    },
    studentTreeData: {
      type: Boolean,
      required: false,
      default: false
    },
    policyTreeData: {
      type: Boolean,
      required: false,
      default: false
    },
    courseTreeData: {
      type: Boolean,
      required: false,
      default: false
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    showArrow: {
      type: Boolean,
      required: false,
      default: true
    },
    showFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showBox: {
      type: Boolean,
      required: false,
      default: true
    },
    loadStyle: {
      type: String,
      required: false
    },
    treeWidth: {
      type: String,
      required: false
    },
    courseType: {
      type: Number,
      required: false
    },
    clickedId: {
      type: Object,
      required: false
    },
    clickedIds: {
      type: Object,
      required: false
    },
    checkStrictly: {
      type: Boolean,
      required: false,
      default: true
    },
    isCheckBoxInit: {
      type: Boolean,
      required: false
    }
  },
  components: {},
  computed: _objectSpread(_objectSpread({}, mapGetters(["chooseDept", "chooseDataScopeDept", "status", "newUserMenus", "defaultCheckedArray", "studentChooseTree", "personChargeData", "hierarchyTree"])), {}, {
    checkBoxInit: {
      get: function get() {
        return this.isCheckBoxInit;
      },
      set: function set(val) {
        this.isCheckBoxInit = val;
      }
    },
    showCheckBox: function showCheckBox() {
      return eval(this.showBox.toLowerCase());
    },
    boxWidth: function boxWidth() {
      return {
        width: this.treeWidth
      };
    },
    hide: function hide() {
      var hideStyle = {
        transition: "all 0.2s ease-out",
        transform: "translate(-" + this.moveDistance + "px, 0)",
        "-ms-transform": "translate(-" + this.moveDistance + "px, 0)"
        /* IE 9 */
        ,
        "-webkit-transform": "translate(-" + this.moveDistance + "px, 0)"
        /* Safari and Chrome */
        ,
        "-o-transform": "translate(-" + this.moveDistance + "px, 0)"
        /* Opera */
        ,
        "-moz-transform": "translate(-" + this.moveDistance + "px, 0)",
        display: "none"
      };
      return hideStyle;
    }
  }),
  data: function data() {
    return {
      TreeData: [],
      defaultExpandIds: [],
      defaultProps: {
        label: "label",
        children: "children",
        isLeaf: false
      },
      filterText: "",
      filterStaticText: "",
      filterPersonText: "",
      filterHierarchyTreeText: "",
      childData: [],
      nodeData: {},
      isShow: true,
      popoverVisible: false,
      isInit: true,
      defaultStaticProps: {
        children: "children",
        label: "name" || "label"
      },
      defaultHierarchyProps: {
        children: "children",
        label: "title" || "label"
      },
      defaultExpandedKeys: [],
      defaultExpandedKeysNode: [],
      // checkedArray: [],
      moveDistance: 0
    };
  },
  watch: {
    courseType: function courseType(newval, oldval) {
      this.TreeDataFun();
    },
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    },
    filterStaticText: function filterStaticText(val) {
      // console.log(999, val)
      this.$refs.staticLoad.filter(val);
    },
    filterPersonText: function filterPersonText(val) {
      this.$refs.personCharge.filter(val);
    },
    filterHierarchyTreeText: function filterHierarchyTreeText(val) {
      this.$refs.hierarchyTree.filter(val);
    },
    "clickedId.key": function clickedIdKey(val) {
      var _this = this;

      //
      this.$nextTick(function () {
        _this.$refs["staticLoad"].setCurrentKey(_this.clickedId.data);
      });
    },
    "clickedIds.key": function clickedIdsKey(val) {
      var _this2 = this;

      //
      this.$nextTick(function () {
        _this2.$refs["hierarchyTree"].setCurrentKey(_this2.clickedIds.data);
      });
    },
    defaultCheckedArray: function defaultCheckedArray(val) {
      if (val.length === 0 && this.loadStyle !== "tree" && this.$refs[this.loadStyle]) {
        this.$refs[this.loadStyle].setCheckedKeys([]);
      }
    },
    nodeData: {
      handler: function handler(newVal, oldVal) {
        if (newVal && Object.keys(newVal).length > 0 && newVal.childNodes.length > 0) {
          newVal.childNodes.forEach(function (child, index) {
            if (!child.data.hasChildren) {
              child.isLeaf = true;
            }
          });
        }
      },
      immediate: true,
      deep: true
    },
    hierarchyTree: {
      handler: function handler(newVal, oldVal) {
        this.generateStaticTree2(newVal);
      },
      immediate: true,
      deep: true
    },
    chooseDept: {
      handler: function handler(newVal, oldVal) {
        this.TreeDataFun();
        this.generateStaticTree(newVal);
      },
      immediate: true,
      deep: true
    },
    personChargeData: {
      handler: function handler(newVal, oldVal) {
        this.generateStaticTree(newVal);
      },
      immediate: true,
      deep: true
    },
    newUserMenus: {
      handler: function handler(newVal, oldVal) {
        this.generateStaticTree(newVal);
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    this.$store.commit("clearChecked");
    this.$store.commit("clearDefaultChecked");
    this.$store.commit("clearCheckedData");
    this.TreeDataFun();
  },
  methods: _objectSpread(_objectSpread({}, mapActions(["editNode", "appendNode"])), {}, {
    hieCurrentKey: function hieCurrentKey(id) {
      var _this3 = this;

      this.$nextTick(function (e) {
        _this3.$refs.hierarchyTree.setCurrentKey(id);
      });
    },
    forCancelCourse: function forCancelCourse(treeData) {
      for (var i = 0; i < treeData.length; i++) {
        treeData[i].disabled = false;

        if (treeData[i].children.length > 0) {
          this.forCancelCourse(treeData[i].children);
        }
      }
    },
    CancelTree: function CancelTree() {
      var treeData = JSON.parse(JSON.stringify(this.chooseDept));
      this.forCancelCourse(treeData);
    },
    forEcharCourse: function forEcharCourse(treeData) {
      for (var i = 0; i < treeData.length; i++) {
        if (treeData[i].orignData.organLevel != this.courseType) {
          treeData[i].disabled = true;
        }

        if (treeData[i].children.length > 0) {
          this.forEcharCourse(treeData[i].children);
        }
      }
    },
    TreeDataFun: function TreeDataFun() {
      var _this4 = this;

      if (this.studentTreeData) {
        // console.log(771,this.studentChooseTree);
        this.TreeData = this.studentChooseTree; // console.log(771,this.studentChooseTree);
      } else if (this.courseTreeData) {
        var treeData = JSON.parse(JSON.stringify(this.chooseDept));
        this.forEcharCourse(treeData);
        this.TreeData = treeData;
      } else if (this.policyTreeData) {
        this.$store.commit("setTabsData", null);
        var tabsData = [{
          name: "全部",
          id: 0,
          hasChildren: true,
          children: []
        }];
        var url = null; // if (this.$route.path == '/policyFile') {
        //     url = '/admin/dict/type/file_type'
        // } else {
        //     url = '/admin/dict/type/file_type_stu'
        // }

        url = "/admin/dict/type/policy_type";
        tabsList(url).then(function (res) {
          if (res.data.code == 0) {
            var data = res.data.data;
            res.data.data.forEach(function (e) {
              var o = {
                id: Number(e.value),
                name: e.label,
                hasChildren: true
              };
              tabsData[0].children.push(o);
            });
            _this4.TreeData = tabsData;

            _this4.$store.commit("setTabsData", tabsData);
          }
        });
      } else {
        this.TreeData = this.chooseDept;
      }
    },
    generateStaticTree: function generateStaticTree(source) {
      var _this5 = this;

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            var nodeIsLeaf = item.hasChildren ? true : false;
            item.label = item.name;
            item.expandId = item.id;
            item.isLeaf = nodeIsLeaf;
            item.popoverId = "popover" + item.id;
            item.popoverVisible = false;

            if (item.parentId === 0 && !_this5.defaultExpandedKeys.includes(item.expandId)) {
              _this5.defaultExpandedKeys.push(item.expandId);
            }

            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };

        filterFun(source); // console.log("source:", source);
        // this.handleStaticNodeClick(source[0])

        this.$nextTick(function () {// this.$refs.staticTree.store.nodesMap[source[0].expandId].expanded = true;
          // console.log("初始化节点：",this.$refs.staticTree.store);
        });
      } else {
        return;
      }
    },
    generateStaticTree2: function generateStaticTree2(source) {
      var _this6 = this;

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            var nodeIsLeaf = item.hasChildren ? true : false;
            item.label = item.name;
            item.expandId = item.id;
            item.isLeaf = nodeIsLeaf;
            item.popoverId = "popover" + item.id;
            item.popoverVisible = false;
            var Hnode = _this6.$store.getters.defaultHierarchyTree;

            if (Hnode.length > 0) {
              _this6.defaultExpandedKeysNode = Hnode;
            } else {
              if (item.level === 1 && !_this6.defaultExpandedKeysNode.includes(item.expandId)) {// this.defaultExpandedKeysNode.push(item.expandId);
              }
            }

            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };

        filterFun(source); // console.log("source:", source);
        // this.handleStaticNodeClick(source[0])

        this.$nextTick(function () {// this.$refs.staticTree.store.nodesMap[source[0].expandId].expanded = true;
          // console.log("初始化节点：",this.$refs.staticTree.store);
        });
      } else {
        return;
      }
    },
    handleStaticNodeClick: function handleStaticNodeClick(data) {
      //父组件通过@nodeClick自定义事件,获取节点参数data.expendId
      this.$emit("nodeClick", data);
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      // console.log(123,data, this.$refs.menuTree.getCheckedKeys(),checked, indeterminate ,this.checkStrictly)
      // console.log(345,this.checkBoxInit)
      if (checked) {
        // console.log(this.$refs.staticLoad.getCheckedNodes())
        this.$emit("BoxClick", "add", this.$refs.staticLoad.getCheckedNodes()); // if(data.parentId===-1&&!this.checkBoxInit){
        //     let recursiveFun=(source)=>{
        //         source.forEach((item,index)=>{
        //             this.$nextTick(()=> {
        //                 console.log("初始化节点：",this.$refs.menuTree.store.nodesMap);
        //                 this.$refs.menuTree.store.nodesMap[source[0].expandId].checked = true;
        //             });
        //             if(item.children.length>0){
        //                 recursiveFun(item.children);
        //             }
        //         })
        //     }
        //     recursiveFun([data]);
        // }else{
        // console.log(33)
        // setTimeout(()=>{
        //     this.checkBoxInit=false;
        // },100)

        this.$store.commit("addChecked", data.id); // }

        this.$store.commit("addCheckedData", data);
      } else {
        this.$emit("BoxClick", "del", this.$refs.staticLoad.getCheckedNodes());
        this.$store.commit("deleteChecked", data.id);
        this.$store.commit("deleteCheckedData", data);
      }
    },
    showTree: function showTree() {
      this.isShow = !this.isShow;
      var boxWidth = this.$refs.treeBox.clientWidth;
      var wrapperWidth;
      this.moveDistance = this.$refs[this.loadStyle].clientWidth;
      this.$emit("arrowClick", this.isShow);
    },
    handleNodeClick: function handleNodeClick(data, node, msg) {
      // console.log("点击节点数据：", data, node, msg);
      //父组件通过@nodeClick自定义事件,参数data.expendId
      this.$emit("nodeClick", data);
    },
    loadNode: function loadNode(node, resolve) {
      var _this7 = this;

      // console.log("--node1--", node);
      this.childData = [];
      var nodeId = node.data === undefined ? Number(this.initId) : node.data.expandId;
      this.getTreeInitData(nodeId).then(function (res) {
        // console.log("--res--", res);
        if (res && res.length > 0) {
          res.forEach(function (item) {
            var nodeIsLeaf = item.hasChildren ? true : false; // console.log(444, nodeIsLeaf);

            var treeObj = {
              label: item.title,
              children: [],
              expandId: item.id,
              isLeaf: nodeIsLeaf,
              hasChildren: item.hasChildren,
              originData: item.orignData,
              popoverId: "popover" + item.id,
              popoverVisible: false
            };

            _this7.childData.push(treeObj);
          });
        } else {
          _this7.childData = [];
        }

        if (node.data !== undefined) {
          _this7.childData = [].concat(_this7.childData, node.data.children);
          node.data.children = _this7.childData;
        }

        return resolve(_this7.childData);
      });
    },
    filterFun: function filterFun(source) {
      var _this8 = this;

      source.filter(function (child, index) {
        if (child.expanded) {
          child.expanded = false;
        }

        if (child.childNodes && child.childNodes.length > 0) {
          _this8.filterFun(child.childNodes);
        }
      });
    },
    expendNodeCollapse: function expendNodeCollapse(data, node) {
      var _this9 = this;

      this.nodeData = node;
      node.parent.childNodes.filter(function (child) {
        if (child.data.expandId !== node.data.expandId) {
          _this9.filterFun([child]);
        }
      });
    },
    closeNodeCollapse: function closeNodeCollapse(data, node) {
      this.filterFun([node]);
    },
    getTreeInitData: function getTreeInitData(expandId) {
      var self = this;
      return new Promise(function (resolve, reject) {// getTreeNode(`/admin/hierarchy/tree/${expandId}`).then(res => {
        //     const result = res.data;
        //     if (result.code == 0) {
        //         resolve(result.data);
        //     }
        // });
      });
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    filterStaticNode: function filterStaticNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    filterPersonNode: function filterPersonNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    filterHierarchyNode: function filterHierarchyNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    append: function append(node, data) {
      this.nodeData = node; // console.log("添加時的data:",node, data);
      //父组件提供@appendNode自定义事件,参数data.expendId,调用模态框添加数据，并返回数据给子组件
      // this.$emit("appendNode", node, data);

      var params = {
        node: node,
        data: data
      };
      this.appendNode(params).then(function (res) {// console.log("新增节点信息成功", res);
      });
    },
    setNode: function setNode(node, data, params) {
      // console.log(4545, node, data, params);
      var newChild = {
        children: [],
        expandId: 1,
        hasChildren: true,
        isLeaf: true,
        label: "新增节点",
        popoverId: "popover" + data.expandId,
        popoverVisible: false
      };

      if (!data.children) {
        this.$set(data, "children", []);
      }

      data.children.push(newChild);
      this.$refs.tree.append(newChild, node);
    },
    edit: function edit(node, data) {
      var params = {
        node: node,
        data: data
      };
      this.editNode(params).then(function (res) {// console.log("编辑节点信息成功", res);
      });
    },
    remove: function remove(node, data) {
      // console.log("刪除時的data:", node, data);
      data.popoverVisible = true;
    },
    cancelRemove: function cancelRemove(node, data) {
      data.popoverVisible = false;
    },
    sureRemove: function sureRemove(node, data) {
      //父组件提供@removeNode自定义事件,参数data.expendId,调用模态框添加数据，并返回数据给子组件
      //this.$emit('removeNode',data);
      var parent = node.parent; // console.log(6677, parent, parent.data);

      var children = parent.data.children || parent.data;
      var index = children.findIndex(function (d) {
        return d.expandId === data.expandId;
      });
      children.splice(index, 1);
      var childNodes = parent.childNodes;
      var key = childNodes.findIndex(function (d) {
        return d.data.expandId === data.expandId;
      }); // console.log(11111, index, key);

      childNodes.splice(key, 1);
      data.popoverVisible = false;
    }
  })
};